import { FormattedMessage } from 'react-intl';
import OverlayTrigger from '@rio-cloud/rio-uikit/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/Tooltip';

import OutlineLabel from '@/features/engineoil/components/OutlineLabel';
import useHoverIntent from '@/hooks/useHoverIntent';

interface ActiveDtcTagProps {
    dtcType: string;
    onHoverIntent?: () => void;
}

const ActiveDtcTag = ({ dtcType, onHoverIntent }: ActiveDtcTagProps) => {
    const [hoverRef] = useHoverIntent(1000, () => {
        onHoverIntent?.();
    });

    return (
        <OverlayTrigger
            placement="top"
            overlay={
                <Tooltip>
                    <FormattedMessage id="intl-msg:engineOil.dtc.tooltip" />
                </Tooltip>
            }
        >
            <div ref={hoverRef} className="display-flex align-items-center">
                <OutlineLabel variant="danger" className="margin-right-5 text-uppercase">
                    <FormattedMessage id={`intl-msg:engineOil.card.customer.dtc.${dtcType}`} />
                </OutlineLabel>
                <span className="rioglyph rioglyph-info-sign text-size-14 text-color-dark" style={{ flexShrink: 0 }} />
            </div>
        </OverlayTrigger>
    );
};

export default ActiveDtcTag;
